import MainLayout from "../../components/Layouts";
import { ReactElement } from "react";
import OrderCreate from "../../components/Orders/CreateOrder/OrderCreate";
import React from "react";

const OrderCreatePage = (): ReactElement => {
  return (
    <MainLayout> 
      <OrderCreate />
    </MainLayout>
  );
};

export default OrderCreatePage;
